import Font18 from '@assets/icons/font-18.svg'
import { Icon } from './Icon'

export const Font18Icon = Icon(Font18)
